<bs-linear-combo-bet-container
    [oddsDisplayFormat]="oddsDisplayFormat"
    [picksTemplate]="picks"
    [infoMessageTemplate]="infoMessage"
    [detailsTemplate]="details"
    [removeButtonStyle]="removeButtonStyle"></bs-linear-combo-bet-container>

<ng-template #infoMessage let-close="close" let-infoMessage="infoMessage" let-infoHeaderTitle="infoHeaderTitle" let-infoHeader="infoHeader">
    <bs-digital-combo-bet-betbuilder-info-message
        [infoMessage]="infoMessage"
        [infoHeaderTitle]="infoHeaderTitle"
        [infoHeader]="infoHeader"
        (close)="close()">
    </bs-digital-combo-bet-betbuilder-info-message>
</ng-template>

<ng-template #picks>
    <bs-digital-pick-list>
        @for (pick of pickList; track pick.id.toString()) {
            @if (isBetBuilderPick(pick)) {
                <bs-linear-bet-builder-pick-display
                    [pick]="pick"
                    [oddsDisplayFormat]="oddsDisplayFormat"
                    [selectionState]="comboBetPick(pick)"
                    [showEditButton]="isEpcotEnabled"
                    [showHeader]="true"
                    [betslipType]="betslipTypeCombo"></bs-linear-bet-builder-pick-display>
            } @else {
                <bs-digital-combo-bet-pick
                    [pick]="pick"
                    [comboBetPickState]="comboBetPick(pick)"
                    [comboBetState]="comboBetState"
                    [oddsDisplayFormat]="oddsDisplayFormat"
                    [removeButtonPosition]="removeButtonPosition"
                    [removeButtonStyle]="removeButtonStyle"
                    [isLinear]="true">
                </bs-digital-combo-bet-pick>
            }
        }
    </bs-digital-pick-list>
</ng-template>

<ng-template #details>
    <bs-linear-combo-bet-builder-details [picks]="pickList"></bs-linear-combo-bet-builder-details>
</ng-template>
